import React, { useState, useRef } from 'react';
import { generateClient } from 'aws-amplify/api';
import AccountSelector from '../AccountSelector';
import { accountsByAccountAndDetailedPremium } from '../../graphql/queries';
const client = generateClient({authMode: 'userPool'});

// This function fetches up to 20 records for the typed accountNum with detailedPremium "Y"
async function fetchPremiumAccountsForAccount(accountNum) {
  let allRecords = [];
  let nextToken = null;
  do {
    const response = await client.graphql({
      query: accountsByAccountAndDetailedPremium,
      variables: {
        account: accountNum,
        detailedPremium: { eq: "Y" },
        nextToken,
        limit: 20, // Don't go beyond this for performance
      }
    });
    allRecords = allRecords.concat(response.data.accountsByAccountAndDetailedPremium.items);
    nextToken = response.data.accountsByAccountAndDetailedPremium.nextToken;
  } while (nextToken);
  return allRecords;
}

export default function AccountSelectorContainer({ selected, setSelected }) {
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const debounceRef = useRef();

  // This fires when the user types in the input field
  const handleInputChange = async (_, value) => {
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (!value || value.trim().length < 3) {
      setDropdownOptions([]);
      setLoading(false);
      return;
    }
    setLoading(true);

    // Debounce user input by 300ms
    debounceRef.current = setTimeout(async () => {
      try {
        const records = await fetchPremiumAccountsForAccount(value.trim());
        // Deduplicate strictly by account number
        const uniqueMap = {};
        records.forEach(account => {
          const acctNum = account.account?.trim();
          if (acctNum && !uniqueMap[acctNum]) {
            uniqueMap[acctNum] = {
              id: acctNum,
              name: `${account.dba} (${acctNum})`,
              uniqueID: account.uniqueID,
              account: acctNum,
              dba: account.dba
            };
          }
        });
        setDropdownOptions(Object.values(uniqueMap));
      } catch (err) {
        console.error('Error fetching premium accounts:', err);
        setDropdownOptions([]);
      }
      setLoading(false);
    }, 300);
  };

  return (
    <AccountSelector
      selected={selected}
      setSelected={setSelected}
      options={dropdownOptions}
      loading={loading}
      onInputChange={handleInputChange}
    />
  );
}
